import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import enUS from '@/locales/en-US'
import zhCN from '@/locales/zh-CN'
import zhTW from '@/locales/zh-TW'
import ruRU from '@/locales/ru-RU'
import esES from '@/locales/es-ES'
import ptPT from '@/locales/pt-PT'
import deDE from '@/locales/de-DE'
import frFR from '@/locales/fr-FR'
import arSA from '@/locales/ar-SA'
import bgBG from '@/locales/bg-BG'
import bnBD from '@/locales/bn-BD'
import csCZ from '@/locales/cs-CZ'
import daDK from '@/locales/da-DK'
import elGR from '@/locales/el-GR'
import etEE from '@/locales/et-EE'
import faIR from '@/locales/fa-IR'
import fiFI from '@/locales/fi-FI'
import heIL from '@/locales/he-IL'
import hiIN from '@/locales/hi-IN'
import hrHR from '@/locales/hr-HR'
import huHU from '@/locales/hu-HU'
import idID from '@/locales/id-ID'
import itIT from '@/locales/it-IT'
import jaJP from '@/locales/ja-JP'
import kkKZ from '@/locales/kk-KZ'
import koKR from '@/locales/ko-KR'
import kyKG from '@/locales/ky-KG'
import ltLT from '@/locales/lt-LT'
import lvLV from '@/locales/lv-LV'
import mrIN from '@/locales/mr-IN'
import msMY from '@/locales/ms-MY'
import myMM from '@/locales/my-MM'
import neNP from '@/locales/ne-NP'
import nlNL from '@/locales/nl-NL'
import noNO from '@/locales/no-NO'
import plPL from '@/locales/pl-PL'
import psAF from '@/locales/ps-AF'
import roRO from '@/locales/ro-RO'
import skSK from '@/locales/sk-SK'
import slSI from '@/locales/sl-SI'
import sqAL from '@/locales/sq-AL'
import srRS from '@/locales/sr-RS'
import svSE from '@/locales/sv-SE'
import swKE from '@/locales/sw-KE'
import thTH from '@/locales/th-TH'
import trTR from '@/locales/tr-TR'
import ukUA from '@/locales/uk-UA'
import uzUZ from '@/locales/uz-UZ'
import viVN from '@/locales/vi-VN'

i18n
// 检测用户当前使用的语言
// 文档: https://github.com/i18next/i18next-browser-languageDetector
.use(LanguageDetector)
// 注入 react-i18next 实例
.use(initReactI18next)
// 初始化 i18next
// 配置参数的文档: https://www.i18next.com/overview/configuration-options
.init({
  debug: true,
  fallbackLng: 'en-US', // 默认使用英文翻译
  interpolation: {
    escapeValue: false,
  },
  resources: {
    'en-US': {
      translation: {
        ...enUS
      }
    },
    'zh-CN': {
      translation: {
        ...zhCN
      }
    },
    'zh-TW': {
      translation: {
        ...zhTW
      }
    },
    'ru-RU': {
      translation: {
        ...ruRU
      }
    },
    'es-ES': {
      translation: {
        ...esES
      }
    },
    'pt-PT': {
      translation: {
        ...ptPT
      }
    },
    'de-DE': {
      translation: {
        ...deDE
      }
    },
    'fr-FR': {
      translation: {
        ...frFR
      }
    },
    'ar-SA': {
      translation: {
        ...arSA
      }
    },
    'bg-BG': {
      translation: {
        ...bgBG
      }
    },
    'bn-BD': {
      translation: {
        ...bnBD
      }
    },
    'cs-CZ': {
      translation: {
        ...csCZ
      }
    },
    'da-DK': {
      translation: {
        ...daDK
      }
    },
    'el-GR': {
      translation: {
        ...elGR
      }
    },
    'et-EE': {
      translation: {
        ...etEE
      }
    },
    'fa-IR': {
      translation: {
        ...faIR
      }
    },
    'fi-FI': {
      translation: {
        ...fiFI
      }
    },
    'he-IL': {
      translation: {
        ...heIL
      }
    },
    'hi-IN': {
      translation: {
        ...hiIN
      }
    },
    'hr-HR': {
      translation: {
        ...hrHR
      }
    },
    'hu-HU': {
      translation: {
        ...huHU
      }
    },
    'id-ID': {
      translation: {
        ...idID
      }
    },
    'it-IT': {
      translation: {
        ...itIT
      }
    },
    'ja-JP': {
      translation: {
        ...jaJP
      }
    },
    'kk-KZ': {
      translation: {
        ...kkKZ
      }
    },
    'ko-KR': {
      translation: {
        ...koKR
      }
    },
    'ky-KG': {
      translation: {
        ...kyKG
      }
    },
    'lt-LT': {
      translation: {
        ...ltLT
      }
    },
    'lv-LV': {
      translation: {
        ...lvLV
      }
    },
    'mr-IN': {
      translation: {
        ...mrIN
      }
    },
    'ms-MY': {
      translation: {
        ...msMY
      }
    },
    'my-MM': {
      translation: {
        ...myMM
      }
    },
    'ne-NP': {
      translation: {
        ...neNP
      }
    },
    'nl-NL': {
      translation: {
        ...nlNL
      }
    },
    'no-NO': {
      translation: {
        ...noNO
      }
    },
    'pl-PL': {
      translation: {
        ...plPL
      }
    },
    'ps-AF': {
      translation: {
        ...psAF
      }
    },
    'ro-RO': {
      translation: {
        ...roRO
      }
    },
    'sk-SK': {
      translation: {
        ...skSK
      }
    },
    'sl-SI': {
      translation: {
        ...slSI
      }
    },
    'sq-AL': {
      translation: {
        ...sqAL
      }
    },
    'sr-RS': {
      translation: {
        ...srRS
      }
    },
    'sv-SE': {
      translation: {
        ...svSE
      }
    },
    'sw-KE': {
      translation: {
        ...swKE
      }
    },
    'th-TH': {
      translation: {
        ...thTH
      }
    },
    'tr-TR': {
      translation: {
        ...trTR
      }
    },
    'uk-UA': {
      translation: {
        ...ukUA
      }
    },
    'uz-UZ': {
      translation: {
        ...uzUZ
      }
    },
    'vi-VN': {
      translation: {
        ...viVN
      }
    }
  }
})
export default i18n
